export default __webpack_public_path__ + "static/media/AGC_2024_R3_QP_Class_2.0203a869.pdf";